<template>
    <div class="recommendPage">
        <swiper :options="swiperOption" ref="mySwiper" class="class_list">
            <swiper-slide v-for="(item, index) in data" :key="index">

                <div class="ctab" @click="goProduct(item.id)">
                    <div class="img">
                        <img :src="item.goods_img" alt="goods_img">
                    </div>
                    <div class="text">{{ item.gc_name }}</div>
                </div>

            </swiper-slide>

            <!-- <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
    </div>
</template>
  
<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            swiperOption: {
                // 设置slidesPerView为你想要显示的slides数量
                slidesPerView: 4,
                spaceBetween: 0, // 分类之间的间距
                loop: true, // 无缝循环
                autoplay: {
                    delay: 3000, // 每3秒自动切换
                    stopOnLastSlide: false,
                    disableOnInteraction: false // 用户交互后不停止自动播放
                },
                // 显示分页
                // pagination: {
                //     el: ".swiper-pagination",
                //     clickable: true //允许分页点击跳转
                // },
                // 设置点击箭头
                // navigation: {
                //     nextEl: ".swiper-button-next",
                //     prevEl: ".swiper-button-prev"
                // }
                // on: {
                //     click: (e) => {
                //         console.log(this);
                //     },
                // },
            }
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    props: {
        data: {
            type: Array,
        }
    },
    mounted() {
        // console.log(this.data);
        // current swiper instance
        // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
        // console.log("this is current swiper instance object", this.swiper);
        // this.swiper.slideTo(3, 1000, false);
    },
    methods: {
        goProduct(id) {
            let params = { 'cate_id': id }
            this.$router.push({ 'name': 'HomeGoodslist', 'query': params })
        },
    },
};
</script>

<style scoped lang="scss">
.recommendPage .swiper-container {
    position: relative;
    width: 100%;
    // height: 5rem;
    margin: 1.5rem 0 1rem;
    box-sizing: border-box;
}

.recommendPage .swiper-container .swiper-slide {
    width: 100%;
    // line-height: 200px;
    color: #000;
    font-size: 16px;
    text-align: center;
}

.class_list {
    padding-left: .7rem;
    padding-right: .7rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .6rem;
    background: #fff;

    .ctab {
        .img {
            width: 3.5rem;

            img {
                max-width: 100%;
                height: 3.5rem;
            }
        }

        .text {
            width: 3.5rem;
            font-size: 12px;
            font-weight: 600;
            text-align: center;
            margin-top: .3rem;
        }
    }
}
</style>
  
  